export enum FunnelSettingsViewModeEnum {
  CREATE = 'create',
  EDIT = 'edit',
}
